import script from "./FamilyGroupMemberList.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyGroupMemberList.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyGroupMemberList.vue?vue&type=style&index=0&id=3bb8524b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bb8524b"]])

export default __exports__